import styled /*, { css } */ from "styled-components";

export const StyledButton = styled.button`
  background-color: #ffffff;
  justify-content: center;
  align-items: center;
  padding: 0.6em 0.8em;
  border-radius: 48px;
  text-transform: uppercase;
  display: flex;
  flex-direction: row;
  border: none;
  margin: 20px;
  font-size: 1.75rem;
  box-shadow: 3px 4px 0 #000000;
  min-width: 5.25rem;

  &:hover {
    box-shadow: 0 4px 4px rgba(0 0 0 / 25%), 0 0 16px #ffffff;
  }
`;

export const SvgContainer = styled.span`
  display: inline-flex;
  align-self: center;
  min-width: 2rem;
  max-height: 2rem;
`;

export const ButtonInner = styled.span`
  display: flex;
  flex-direction: row;
  gap: 0.8rem;
`;

export const ButtonCentered = styled(StyledButton)`
  align-self: center;
`;

export const ButtonLarge = styled(StyledButton)`
  font-size: 2em;
`;

export const ButtonAbsolute = styled(StyledButton)`
  position: absolute;
`;

export const ButtonBottomRight = styled(ButtonAbsolute)`
  right: 0;
  bottom: 0;
`;

export const ButtonTopRight = styled(ButtonAbsolute)`
  right: 0;
  top: 0;
`;
